module.exports = __webpack_public_path__ + "img/ExaCode.f3d065ac.png";